import { render, staticRenderFns } from "./removeLabel.vue?vue&type=template&id=8cfc16a2&scoped=true&"
import script from "./removeLabel.vue?vue&type=script&lang=js&"
export * from "./removeLabel.vue?vue&type=script&lang=js&"
import style0 from "./removeLabel.vue?vue&type=style&index=0&id=8cfc16a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfc16a2",
  null
  
)

export default component.exports